import {
  AnamnesisDtoAnamnesisType,
  ClinicalReportAnamnesisDtoPreviousDiagnoseStatus,
  ClinicalReportAnamnesisDtoPreviousTherapyStatus,
  ImagingDiagnosisDtoImagingProcedure,
  SecondaryDiagnosisDtoDiagnosisType,
  SocialAnamnesisDtoDietType,
  SocialAnamnesisDtoEducationLevel,
  SocialAnamnesisDtoEmploymentStatus,
  SocialAnamnesisDtoHousingStatus,
  SocialAnamnesisDtoImmunosuppressionStatus,
  SocialAnamnesisDtoMaritalStatus,
  SocialAnamnesisDtoSportFrequency,
  SymptomDtoSymptomType,
} from '../api/generated/model';

export function getAnamnesisTypeName(anamnesisType: AnamnesisDtoAnamnesisType) {
  switch (anamnesisType) {
    case AnamnesisDtoAnamnesisType.MEDICAL:
      return 'Ärztliche Anamnese';
    case AnamnesisDtoAnamnesisType.SELF:
      return 'Eigen-Anamnese';
    case AnamnesisDtoAnamnesisType.EXTERNAL:
      return 'Fremd-Anamnese';
  }
}

export function getSymptomTypeName(symptomType: SymptomDtoSymptomType) {
  switch (symptomType) {
    case SymptomDtoSymptomType.COUGH:
      return 'Husten';
    case SymptomDtoSymptomType.PHLEGM:
      return 'Auswurf';
    case SymptomDtoSymptomType.LACK_OF_ENERGY:
      return 'Energielosigkeit';
    case SymptomDtoSymptomType.HEMOPTYSIS:
      return 'Hämoptoe / Hämoptyse';
    case SymptomDtoSymptomType.WEIGHT_LOSS:
      return 'Gewichtsverlust';
    case SymptomDtoSymptomType.LOSS_OF_APPETITE:
      return 'Appetitlosigkeit';
    case SymptomDtoSymptomType.NIGHT_SWEATS:
      return 'Nachtschweiss';
    case SymptomDtoSymptomType.FEVER:
      return 'Fieber';
    case SymptomDtoSymptomType.CHEST_PAIN:
      return 'Thorax-Schmerzen';
  }
}

export function getSecondaryDiagnosisTypeName(secondaryType: SecondaryDiagnosisDtoDiagnosisType) {
  switch (secondaryType) {
    case SecondaryDiagnosisDtoDiagnosisType.HIV:
      return 'HIV';
    case SecondaryDiagnosisDtoDiagnosisType.DIABETES:
      return 'Diabetes';
    case SecondaryDiagnosisDtoDiagnosisType.CORONARY_HEART_DISEASE:
      return 'KHK';
    case SecondaryDiagnosisDtoDiagnosisType.C2_ABUSE:
      return 'C2-Abusus';
    case SecondaryDiagnosisDtoDiagnosisType.MENTAL_HEALTH:
      return 'psych. Erkrankungen';
    case SecondaryDiagnosisDtoDiagnosisType.POLY_DRUG_USE:
      return 'Polytoxikomanie';
    case SecondaryDiagnosisDtoDiagnosisType.CA:
      return 'CA';
  }
}

export function getEducationLevelName(educationLevel: SocialAnamnesisDtoEducationLevel) {
  switch (educationLevel) {
    case SocialAnamnesisDtoEducationLevel.UNKNOWN:
      return 'Unbekannt';
    case SocialAnamnesisDtoEducationLevel.PRIMARY:
      return 'Primar';
    case SocialAnamnesisDtoEducationLevel.SECONDARY_1:
      return 'Sekundar I';
    case SocialAnamnesisDtoEducationLevel.SECONDARY_2:
      return 'Sekundar II';
    case SocialAnamnesisDtoEducationLevel.TERTIARY:
      return 'Tertiär';
    case SocialAnamnesisDtoEducationLevel.SPECIALIST:
      return 'Fachausbildung';
    case SocialAnamnesisDtoEducationLevel.APPRENTICESHIP:
      return 'Berufslehre';
  }
}

export function getHousingStatusName(housingStatus: SocialAnamnesisDtoHousingStatus) {
  switch (housingStatus) {
    case SocialAnamnesisDtoHousingStatus.UNKNOWN:
      return 'Unbekannt';
    case SocialAnamnesisDtoHousingStatus.ASSISTED_LIVING:
      return 'Betreutes Wohnen';
    case SocialAnamnesisDtoHousingStatus.PRISON:
      return 'Justizanstalt';
    case SocialAnamnesisDtoHousingStatus.HOMELESS:
      return 'Obdachlos';
    case SocialAnamnesisDtoHousingStatus.ASYLUM:
      return 'Asyl-Unterkunft';
    case SocialAnamnesisDtoHousingStatus.HIDING:
      return 'Untergetaucht';
    case SocialAnamnesisDtoHousingStatus.SHARED:
      return 'Wohngemeinschaft';
    case SocialAnamnesisDtoHousingStatus.PRIVATE:
      return 'Privathaushalt';
    case SocialAnamnesisDtoHousingStatus.MEDICAL_FACILITY:
      return 'medizinische Einrichtung';
  }
}

export function getEmploymentStatusName(employmentStatus: SocialAnamnesisDtoEmploymentStatus) {
  switch (employmentStatus) {
    case SocialAnamnesisDtoEmploymentStatus.UNKNOWN:
      return 'Unbekannt';
    case SocialAnamnesisDtoEmploymentStatus.EMPLOYED:
      return 'Angestellt';
    case SocialAnamnesisDtoEmploymentStatus.SELF_EMPLOYED:
      return 'Selbständig';
    case SocialAnamnesisDtoEmploymentStatus.UNEMPLOYED:
      return 'Arbeitslos';
    case SocialAnamnesisDtoEmploymentStatus.STUDENT:
      return 'Schüler:in';
    case SocialAnamnesisDtoEmploymentStatus.IN_TRAINING:
      return 'Ausbildung/Studium';
    case SocialAnamnesisDtoEmploymentStatus.RETIRED:
      return 'Pensioniert';
  }
}

export function getMaritalStatusName(maritalStatus: SocialAnamnesisDtoMaritalStatus) {
  switch (maritalStatus) {
    case SocialAnamnesisDtoMaritalStatus.UNKNOWN:
      return 'Unbekannt';
    case SocialAnamnesisDtoMaritalStatus.SINGLE:
      return 'Ledig';
    case SocialAnamnesisDtoMaritalStatus.MARRIED:
      return 'Verheiratet';
    case SocialAnamnesisDtoMaritalStatus.UNMARRIED:
      return 'Unverheiratet';
    case SocialAnamnesisDtoMaritalStatus.REGISTERED_PARTNERSHIP:
      return 'In eingetragener Partnerschaft';
    case SocialAnamnesisDtoMaritalStatus.DIVORCED:
      return 'Geschieden';
    case SocialAnamnesisDtoMaritalStatus.DISSOLVED_PARTNERSHIP:
      return 'Aufgelöste Partnerschaft';
    case SocialAnamnesisDtoMaritalStatus.WIDOWED:
      return 'Verwitwet';
  }
}

export function getSportFrequencyName(sportFrequency: SocialAnamnesisDtoSportFrequency) {
  switch (sportFrequency) {
    case SocialAnamnesisDtoSportFrequency.UNKNOWN:
      return 'Unbekannt';
    case SocialAnamnesisDtoSportFrequency.ACTIVELY:
      return 'Aktivsport';
    case SocialAnamnesisDtoSportFrequency.OCCASIONALLY:
      return 'Gelegentlich';
    case SocialAnamnesisDtoSportFrequency.NEVER:
      return 'Kein Sport';
  }
}

export function getDietName(diet: SocialAnamnesisDtoDietType) {
  switch (diet) {
    case SocialAnamnesisDtoDietType.UNKNOWN:
      return 'Unbekannt';
    case SocialAnamnesisDtoDietType.RAW:
      return 'Rohkost';
    case SocialAnamnesisDtoDietType.MIXED:
      return 'Mischkost';
    case SocialAnamnesisDtoDietType.VEGAN:
      return 'Veganismus';
    case SocialAnamnesisDtoDietType.VEGETARIAN:
      return 'Vegetarismus';
    case SocialAnamnesisDtoDietType.PALEO:
      return 'Paleo';
    case SocialAnamnesisDtoDietType.WHOLE_FOODS:
      return 'Vollwertkost';
    case SocialAnamnesisDtoDietType.CLEAN_EATING:
      return 'Clean Eating';
    case SocialAnamnesisDtoDietType.FLEXITARIAN:
      return 'Flexitarismus';
  }
}

export function getPreviousDiagnoseStatusName(status: ClinicalReportAnamnesisDtoPreviousDiagnoseStatus) {
  switch (status) {
    case ClinicalReportAnamnesisDtoPreviousDiagnoseStatus.YES:
      return 'Ja';
    case ClinicalReportAnamnesisDtoPreviousDiagnoseStatus.NO:
      return 'Nein';
    case ClinicalReportAnamnesisDtoPreviousDiagnoseStatus.UNKNOWN:
      return 'Unbekannt';
  }
}

export function getPreviousTherapyStatusName(status: ClinicalReportAnamnesisDtoPreviousTherapyStatus) {
  switch (status) {
    case ClinicalReportAnamnesisDtoPreviousTherapyStatus.YES:
      return 'Ja';
    case ClinicalReportAnamnesisDtoPreviousTherapyStatus.NO:
      return 'Nein';
    case ClinicalReportAnamnesisDtoPreviousTherapyStatus.UNKNOWN:
      return 'Unbekannt';
  }
}

export function getImagingProcedureTypenName(type: ImagingDiagnosisDtoImagingProcedure) {
  switch (type) {
    case ImagingDiagnosisDtoImagingProcedure.MRI:
      return 'MRI';
    case ImagingDiagnosisDtoImagingProcedure.CT_SCAN:
      return 'CT Scan';
    case ImagingDiagnosisDtoImagingProcedure.XRAY:
      return 'Röntgen';
  }
}

export function getImmunosuppressionStatusName(status: SocialAnamnesisDtoImmunosuppressionStatus) {
  switch (status) {
    case SocialAnamnesisDtoImmunosuppressionStatus.IMMUNOSUPPRESSED:
      return 'Ja';
    case SocialAnamnesisDtoImmunosuppressionStatus.NOT_IMMUNOSUPPRESSED:
      return 'Nein';
    case SocialAnamnesisDtoImmunosuppressionStatus.UNKNOWN:
      return 'Unbekannt';
  }
}
